import { useApi } from '@omnipresentgroup/api';
import type {
  GetContractorsResponse,
  GetContractorsResponseAPI,
} from '@omnipresentgroup/types';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';
import { transformGetContractorsResponseFromAPI } from '../mappers';

export const useContractors = (
  page: string | number,
  size: string | number,
  company_id?: string,
): UseQueryResult<GetContractorsResponse, unknown> => {
  const { GET } = useApi();

  return useQuery({
    queryKey: [API_PATH, page, size, company_id],
    queryFn: () =>
      GET<GetContractorsResponseAPI>(
        `${API_BASE}/${API_PATH}`,
        {},
        {
          page: `${page}`,
          size: `${size}`,
          ...(company_id ? { company_id } : {}),
        },
      ),
    select: transformGetContractorsResponseFromAPI,
  });
};
